import { Component, Input } from '@angular/core';

@Component({
  selector: 'libero-preload-spinner',
  templateUrl: './preload-spinner.component.html',
  styleUrls: ['./preload-spinner.component.scss'],
  standalone: false
})
export class PreloadSpinnerComponent {
  @Input() public inverse? = false;
  @Input() public responsive? = false;
  @Input() public inline? = false;
  @Input() public customStyle? = {}
}
